import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'Absence Percentage Calculator - Calculate Absence Percentage Based on Total Attendance and Total Absences';
const DESCRIPTION = 'The Absence Percentage Calculator calculates the absence percentage based on total attendance and total absences.';
const KEYWORDS = 'Absence percentage, Calculate absence percentage, Absence percentage calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/absence-percentage';
function Calculator() {
    const [totalAttendees, setTotalAttendees] = useState('');
    const [totalAbsences, setTotalAbsences] = useState('');
    const [absencePercentage, setAbsencePercentage] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!totalAttendees || !totalAbsences) {
            setError('Please enter the total attendance and total absences correctly');
            setAbsencePercentage('');
            return;
        }
        const attendeesValue = parseInt(totalAttendees);
        const absencesValue = parseInt(totalAbsences);
        if (isNaN(attendeesValue) || isNaN(absencesValue) || attendeesValue < 0 || absencesValue < 0) {
            setError('Please enter valid non-negative values for total attendance and total absences');
            setAbsencePercentage('');
            return;
        }
        const percentage = (absencesValue / (attendeesValue + absencesValue)) * 100;
        setAbsencePercentage(percentage.toFixed(2));
        setError('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                    <h2 style={{fontSize:'18px'}}>How to Calculate Absence Percentage</h2>
                                        <p>
                                            To calculate the absence percentage, you need to calculate the total attendance and know the total number of people present and absent.
                                            Then, divide the total absences by the total count, and then multiply by 100% to get the absence percentage.
                                        </p>
                                        <p>
                                            Absence Percentage = (Total Absences / (Total Attendance + Total Absences)) * 100%
                                        </p>
                                        <p>
                                            This calculator can be used to calculate the absence percentage based on the entered values.
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <div dir="ltr">
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Total Attendance</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Total attendance"
                                                        value={totalAttendees}
                                                        onChange={(e) => setTotalAttendees(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Total Absences</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Total absences"
                                                        value={totalAbsences}
                                                        onChange={(e) => setTotalAbsences(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    Calculate Absence Percentage
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                                ) : (
                                                    <>
                                                        {absencePercentage !== '' && (
                                                            <>
                                                                <p className='p-3 mb-2 bg-success text-white'>
                                                                    Absence Percentage: {absencePercentage}%
                                                                </p>
                                                                <p className='p-3 mb-2 bg-success text-white'>
                                                                    Attendance Percentage: {100 - absencePercentage}%
                                                                </p>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.mathCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default Calculator;
